import { AfterContentInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { NgSelectComponent, NgSelectConfig, NgSelectModule } from '@ng-select/ng-select';
import { HelperService } from 'src/sb-tools/typescript/services/helper.service';
import { FormService } from '../../../common/services/form.service';
import { FormFieldsValidationService } from 'src/sb-modules/Frontend-form-field-module/common/services/form-fields-validation.service';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { SelectAccessibilityDirective } from '@form-field-module/common/directives/select-accessibility.directive';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { NgClass } from '@angular/common';

@Component({
    selector: 'sb-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [NgSelectModule, SelectAccessibilityDirective, FormsModule, FocusDirective, NgClass],
})
export class SelectComponent implements OnInit, AfterContentInit {
    @Input() formField: Field | ClientField;

    @ViewChild('select') selectElement: NgSelectComponent;

    isMobileOrTabletDevice = HelperService.isMobileOrTabletDevice;
    labelText: string;
    selectedValue = null;

    constructor(
        public formService: FormService,
        private selectConfig: NgSelectConfig,
        private changeDetectorRef: ChangeDetectorRef,
        private formFieldsValidationService: FormFieldsValidationService,
    ) {
        this.selectConfig.notFoundText = 'No results found';
    }

    ngOnInit() {
        this.labelText = this.formField.label || this.formField.name;

        if (
            this.formField.value &&
            !this.formFieldsValidationService.isValueInPossibleValuesList(this.formField, this.formField.value)
        ) {
            this.formField.value = null;
        }

        this.selectedValue = this.formField.value || null;
    }

    ngAfterContentInit() {
        // fix for error: Expression has changed after it was checked. Previous value for 'focusableSelectElement': 'undefined'. Current value: '[object Object]'
        this.changeDetectorRef.detectChanges();
    }

    onSelect() {
        this.formField.value = this.selectedValue || '';
    }
}
